<nav class="tabs">
  <div
    class="tab"
    (click)="uiService.toggleMobileUIState('browse')"
    [class.active]="(uiService.uiStateMobile().browse || isBrowseTab) && !(uiService.uiStateMobile().chat || uiService.uiStateMobile().games)"
  >
    <span class="tab-icon">
      <app-icon class="tab-icon" [width]="18" [icon]="'backpack'" />
    </span>
    <span class="tab-title"> browse </span>
  </div>
  <div
    class="tab"
    (click)="uiService.toggleMobileUIState('games')"
    [class.active]="(uiService.uiStateMobile().games || isGameTab) && !(uiService.uiStateMobile().chat || uiService.uiStateMobile().browse)"
  >
    <span class="tab-icon">
      <app-icon class="tab-icon" [width]="18" [icon]="'backpack'" />
    </span>
    <span class="tab-title">games</span>
  </div>
  <div
    class="tab"
    routerLink="/"
    [routerLinkActiveOptions]="{ exact: true }"
    #rlaHome="routerLinkActive"
    routerLinkActive
    [ngClass]="{ active: !isOpenUIStateItem && rlaHome.isActive }"
  >
    <span class="tab-icon">
      <app-icon class="tab-icon" [width]="18" [icon]="'home'" />
    </span>
    <span class="tab-title">home</span>
  </div>
  <div class="tab" (click)="uiService.openStoreModal()">
    <span class="tab-icon">
      <app-icon class="tab-icon" [width]="18" [icon]="'wallet'" />
    </span>
    <span class="tab-title">wallet</span>
  </div>
  <div class="tab" (click)="uiService.toggleMobileUIState('chat')" [class.active]="uiService.uiStateMobile().chat">
    <span class="tab-icon">
      <app-icon class="tab-icon" [width]="18" [icon]="'chat'" />
    </span>
    <span class="tab-title">chat</span>
  </div>
</nav>
